import http from "infra/http";
import URL from "core/resources/urls";
import { useQuery } from "react-query";
import {
  AllJobsResponse,
  GetJobsByGroupRequest,
  groupJobsResponse,
} from "../types";

export const useGetJobsByGroup = ({ groupId }: GetJobsByGroupRequest) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [URL.RECURRING_JOB_GROUP.OBTER_JOBS_BY_GROUP_ID(groupId)],
    enabled: !!groupId,
    queryFn: async () => {
      const { data } = await http.get<groupJobsResponse, any>(
        URL.RECURRING_JOB_GROUP.OBTER_JOBS_BY_GROUP_ID(groupId),
      );
      return { data: data };
    },
    keepPreviousData: true,
  });

  return { data: data?.data, isLoading: isLoading, refetch: refetch };
};

export const useGetalAllJobs = () => {
  return useQuery({
    queryKey: [URL.RECURRING_JOB_GROUP.OBTER_ALL_JOBS],
    queryFn: async () => {
      const { data } = await http.get<AllJobsResponse[], any>(
        URL.RECURRING_JOB_GROUP.OBTER_ALL_JOBS(),
      );

      return { data: data };
    },
  });
};
